const debounce = {
    inserted: function (el, binding, vnode, oldVnode) {

        let self = vnode.context
        let { arg, modifiers, value, expression, } = binding
        let flag = false
        el.addEventListener('click', (e) => {
            if (flag) {
                return false
            }
            if (modifiers) {
                if (modifiers.hasOwnProperty('prevent')) {
                    if (e.stopPropagation) {
                        e.stopPropagation()
                    } else {
                        e.cancelBubble = true
                    }
                }
            }
            arg && self[arg](value || '')
            flag = true
            setTimeout(() => {
                flag = false
            }, Number(arg) * 1000 || 2000)
        })
    },
}

export default debounce